import React from "react";
import AvatarLevelUpTitle from "./AvatarLevelUpTitle";
import { defaultAvatarUrl } from "../constants";
import {
    getDisplayActivityScore,
    getLevelTitle,
    normalizeNumber,
} from "./levelUtils";
import { useLanguage } from "../contexts/LanguageContext";
import "../styles/components/UserXpAvatar.scss";

const formatLabel = (label) => {
    return String(label || "").replace(/\s*:+\s*$/, "");
};

const formatActivityScore = (score) => {
    const safeScore = normalizeNumber(score);

    if (Number.isInteger(safeScore)) {
        return safeScore;
    }

    return Number(safeScore.toFixed(2));
};

const UserXpAvatar = ({
  avatarUrl,
  activityScore = 0,
  fallbackActivityScore = 0,
  showTitle = true,
  showActivity = true,
  titleLabel = "Titre",
  activityLabel = "Activité",
  className = "",
  id,
  userId = null,
}) => {
    const { t } = useLanguage();

    const rawScore = normalizeNumber(
        activityScore ?? fallbackActivityScore ?? 0
    );

    const effectiveScore = getDisplayActivityScore(rawScore, userId);

    const levelKey = getLevelTitle(effectiveScore);
    const translatedLevelTitle = t(`forum.levelTitles.${levelKey}`);

    const displayedScore = formatActivityScore(effectiveScore);
    const cleanTitleLabel = formatLabel(titleLabel);
    const cleanActivityLabel = formatLabel(activityLabel);

    return (
        <div className={`user-xp-avatar ${className}`}>
            <AvatarLevelUpTitle
                avatarUrl={avatarUrl || defaultAvatarUrl}
                level={effectiveScore}
            />

            {(showTitle || showActivity) && (
                <div className="user-xp-avatar__info">
                    {showTitle && (
                        <p className="user-xp-avatar__title">
                            <span>{cleanTitleLabel} : </span>
                            <strong>{translatedLevelTitle}</strong>
                        </p>
                    )}

                    {showActivity && (
                        <p className="user-xp-avatar__activity">
                            <span>{cleanActivityLabel} : </span>
                            <strong>{displayedScore}</strong>
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default UserXpAvatar;
